module.exports = __webpack_public_path__ + "img/horse.43e8fc28.jpg";